import React, { useState, useEffect } from 'react';
import {
  TextField,
  Button,
  Box,
  Typography, IconButton, InputAdornment,
  Paper,
  Tabs,
  Tab,
  Grid,
  FormControl,
  InputLabel,
  Select,
  Alert,
  MenuItem
} from '@mui/material';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { useAuth } from '../../hooks/useAuth';
import { useNavigate, Link } from 'react-router-dom';
import { signIn, signUp } from '../../api/authService';
import { useUser } from '../../context/UserContext';
import { fetchPublicEventTypes } from '../../api/guestRegistrationService';
import FormCard from '../FormCard';

function SignInForm() {
  // Tab state: 0 for Sign In, 1 for Sign Up
  const [tabValue, setTabValue] = useState(0);

  // Sign In form fields
  const [signInEmail, setSignInEmail] = useState('');
  const [signInPassword, setSignInPassword] = useState('');

  // Sign Up form fields a
  const [signUpFirstName, setSignUpFirstName] = useState('');
  const [signUpLastName, setSignUpLastName] = useState('');
  const [signUpEmail, setSignUpEmail] = useState('');
  const [signUpMobile, setSignUpMobile] = useState('');
  const [signUpPassword, setSignUpPassword] = useState('');
  const [signUpConfirmPassword, setSignUpConfirmPassword] = useState('');
  const [signUpAddressLine1, setSignUpAddressLine1] = useState('');
  const [signUpAddressLine2, setSignUpAddressLine2] = useState('');
  const [signUpCity, setSignUpCity] = useState('');
  const [signUpState, setSignUpState] = useState('');
  const [signUpZip, setSignUpZip] = useState('');
  const [error, setError] = useState(null);
    const {updateUser} = useUser();
    const [success, setSuccess] = useState("");
  const [publicEvents, setPublicEvents] = useState([]);

  const [inputFields, setInputFields] = useState({
              orgId: "1",
              memberType: "parent",
              firstName: "",
              lastName: "",
              mobileNumber: "",
              email: "",
              streetAddress: "",
              streetAddress1: "",
              streetAddress2: "",
              city: "",
              state: "",
              postalCode: ""
          })
  
  const { signIn: signInContext } = useAuth();
  const { accessToken, handleLogin } = useAuth();
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false); // State to manage password visibility

  //console.log("sign-in form data :", (inputFields));


  // Validation errors
  const [signInErrors, setSignInErrors] = useState({});
  const [signUpErrors, setSignUpErrors] = useState({});

  useEffect(() => {
    if (accessToken) {
      navigate('/EventTypesForm');
    }
  }, [accessToken, navigate]);

  useEffect(() => {
    fetchPublicEventTypes()
      .then((events) => setPublicEvents(events.filter((e) => e.parentEventTypeId === null)))
      .catch(() => {});
  }, []);

  useEffect(() => {
    inputFields.streetAddress = (inputFields.streetAddress1.trim() + " " + inputFields.streetAddress2.trim()).trim();    
    //inputFields.streetAddress = (inputFields.streetAddress1 + ", " + inputFields.streetAddress2);
    console.log("Inside use :");

  }, [inputFields.streetAddress1, inputFields.streetAddress2]);



  const handleTabChange = (event, newValue) => {
    setError(null); // Clear any previous errors
    setTabValue(newValue);
  };

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };


  const validateMobile = (mobile) => {
    return true;
  };

  const validateZip = (zip) => {
    const zipRegex = /^\d{5}$/;
    return zipRegex.test(zip);
  };


  const handleSubmit = async (e) => {
    setError(null);

    try {
      const data = await signIn(signInEmail, signInPassword);
      signInContext(data.accessToken);
      updateUser("ttl", data.ttl); // Set the token TTL
      handleLogin(); // Set the IsLoggedIn state to true
      navigate('/EventTypesForm');
    } catch (err) {
      setError(err.message);
    }
  };

  function handleSignUpChange(e) {
    let newForm = { ...inputFields };
    newForm[e.target.name] = e.target.value;
    setInputFields(newForm);}

  const handleSignInSubmit = (e) => {
    e.preventDefault();
    let errors = {};

    if (!signInEmail || !validateEmail(signInEmail)) {
      errors.email = 'Please enter a valid email address';
    }
    if (!signInPassword) {
      errors.password = 'Password cannot be empty';
    }

    setSignInErrors(errors);

    if (Object.keys(errors).length === 0) {
      handleSubmit();
    }
  };

  const handleSignUpSubmit = async (e) => {
    e.preventDefault();
    let errors = {};
    // Validate Name Fields and check for existing account with same email or mobile number
    try {
      const { response, data } = await signUp( inputFields );
    
      console.log("Sign up New User :", data, response);

      if (response.ok) {
        console.log("Sign up response is good :", response);
        updateUser("newMember", true);
        updateUser("email", inputFields.email);
        updateUser("mobileNumber", inputFields.mobileNumber);
        updateUser("existingHouseholdLastName", data.existingHouseholdLastName);
        inputFields.postalCode = data.postalCode;
        updateUser("inputFields", inputFields);
        setSuccess("Email sent successfully!");
        if (data.householdAddressExists === "true") {
          navigate("/SameHousehold"); // Route to SameHousehold
        } else {
        navigate("/ValidateOTP"); // Route to ValidateOTP
      }
     } else {
        setError(data.message );
      }
      
    } catch (err) {
      setError("An error occurred. Please try again.");
    }


    // Validate Name Fields
    if (!signUpFirstName.trim()) {
      errors.firstName = 'First Name is required';
    }
    if (!signUpLastName.trim()) {
      errors.lastName = 'Last Name is required';
    }

    // Validate Email
    if (!signUpEmail || !validateEmail(signUpEmail)) {
      errors.email = 'Please enter a valid email address';
    }
    // Validate Mobile
    if (!signUpMobile || !validateMobile(signUpMobile)) {
      errors.mobile = 'Please enter a valid mobile number';
    }

    // Validate Password
    if (!signUpPassword || signUpPassword.length < 6) {
      errors.password = 'Password should be at least 6 characters long';
    }
    if (signUpConfirmPassword !== signUpPassword) {
      errors.confirmPassword = 'Passwords do not match';
    }

    // Validate Address Fields
    if (!signUpAddressLine1.trim()) {
      errors.addressLine1 = 'Address Line 1 is required';
    }
    if (!signUpCity.trim()) {
      errors.city = 'City is required';
    }
    if (!signUpState.trim()) {
      errors.state = 'State is required';
    }
    if (!validateZip(signUpZip)) {
      errors.zip = 'Please enter a valid 5-digit Zip code';
    }

    setSignUpErrors(errors);

    if (Object.keys(errors).length === 0) {
      // Proceed with actual sign-up logic
      console.log('Sign Up:', {
        firstName: signUpFirstName,
        lastName: signUpLastName,
        email: signUpEmail,
        mobile: signUpMobile,
        password: signUpPassword,
        address: {
          line1: signUpAddressLine1,
          line2: signUpAddressLine2,
          city: signUpCity,
          state: signUpState,
          zip: signUpZip
        }
      });
    }
  };



  // cmdfw.org theme tokens
  const amber = '#B8860A';
  const navy = '#1A3A6B';
  const pageBg = '#f8f7f2';
  const btnSx = {
    bgcolor: amber,
    color: '#fff',
    fontWeight: 700,
    letterSpacing: 1,
    borderRadius: 1,
    '&:hover': { bgcolor: '#9a6f08' },
  };

  return (
    <Box sx={{ pt: 4, pb: 1, px: { xs: 2, md: 4 }, display: 'flex', justifyContent: 'center' }}>
      <Box sx={{
        bgcolor: pageBg,
        borderRadius: 3,
        boxShadow: 4,
        p: { xs: 2, md: 3 },
        width: '100%',
        maxWidth: 1300,
        alignSelf: 'flex-start',
      }}>
      <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' }, alignItems: 'flex-start', gap: 2 }}>

        {/* ── Event cards — left ── */}
        <Box sx={{ width: { xs: '100%', md: 800 }, flexShrink: 0, mx: { xs: 2, md: 0 } }}>
          <Grid container spacing={3}>
            {publicEvents.map((event) => (
              <Grid item xs={12} sm={6} md={4} key={event.eventTypeId} sx={{ display: 'flex' }}>
                <FormCard
                  title={event.name}
                  route={event.route}
                  buttonName={event.name === 'Donation' ? 'Donate' : event.name === 'Banquet' ? 'Purchase' : 'Register'}
                  eventImage={event.imagePath}
                />
              </Grid>
            ))}
          </Grid>
        </Box>

        {/* ── Login / Sign-up card — right ── */}
        <Box sx={{ width: { xs: '100%', md: 360 }, flexShrink: 0, mx: { xs: 2, md: 0 } }}>
          <Paper elevation={4} sx={{ p: 4, borderRadius: 2 }}>
            <Typography variant="h5" align="center" gutterBottom
              sx={{ color: navy, fontFamily: 'Georgia, serif', fontWeight: 700, mb: 2 }}>
              Welcome
            </Typography>

            <Tabs
              value={tabValue}
              onChange={handleTabChange}
              variant="fullWidth"
              sx={{ mb: 1, '& .MuiTabs-indicator': { bgcolor: amber }, '& .Mui-selected': { color: `${amber} !important` } }}
            >
              <Tab label="LOGIN" sx={{ fontWeight: 700 }} />
              <Tab label="SIGN UP" sx={{ fontWeight: 700 }} />
            </Tabs>

            {tabValue === 0 && (
              <Box component="form" onSubmit={handleSignInSubmit} noValidate sx={{ mt: 1 }}>
                <TextField fullWidth label="Email" type="email" margin="normal"
                  value={signInEmail} onChange={(e) => setSignInEmail(e.target.value)}
                  error={!!signInErrors.email} helperText={signInErrors.email} />
                <TextField fullWidth label="Password"
                  type={showPassword ? 'text' : 'password'} margin="normal"
                  value={signInPassword} onChange={(e) => setSignInPassword(e.target.value)}
                  error={!!signInErrors.password} helperText={signInErrors.password}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton onClick={() => setShowPassword(!showPassword)} edge="end">
                          {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
                <Button type="submit" variant="contained" fullWidth sx={{ mt: 3, ...btnSx }}>
                  LOGIN
                </Button>
                {error && <Alert severity="error" sx={{ mt: 2 }}>{error}</Alert>}
                <Grid container sx={{ mt: 1 }}>
                  <Grid item xs={6}>
                    <Link to="/ForgotUsername" style={{ color: amber, fontSize: '0.75rem' }}>Forgot Username?</Link>
                  </Grid>
                  <Grid item xs={6} sx={{ textAlign: 'right' }}>
                    <Link to="/ForgotPassword" style={{ color: amber, fontSize: '0.75rem' }}>Forgot Password?</Link>
                  </Grid>
                </Grid>
              </Box>
            )}

            {tabValue === 1 && (
              <Box component="form" onSubmit={handleSignUpSubmit} sx={{ mt: 2 }}>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6}>
                    <TextField required fullWidth id="fName" label="Parent First Name" name="firstName"
                      variant="outlined" value={inputFields.firstName} onChange={handleSignUpChange} />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField required fullWidth id="lName" label="Parent Last Name" name="lastName"
                      variant="outlined" value={inputFields.lastName} onChange={handleSignUpChange} />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField required fullWidth type="number" id="mobile" label="Mobile Phone" name="mobileNumber"
                      variant="outlined" value={inputFields.mobileNumber} onChange={handleSignUpChange} />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField required fullWidth type="email" id="email" label="Email" name="email"
                      variant="outlined" value={inputFields.email} onChange={handleSignUpChange} />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField required fullWidth id="streetAddress1" label="Address Line 1" name="streetAddress1"
                      variant="outlined" value={inputFields.streetAddress1} onChange={handleSignUpChange} />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField fullWidth id="streetAddress2" label="Address Line 2 (Optional)" name="streetAddress2"
                      variant="outlined" value={inputFields.streetAddress2} onChange={handleSignUpChange} />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField fullWidth id="city" label="City" name="city"
                      variant="outlined" value={inputFields.city} onChange={handleSignUpChange} />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <FormControl fullWidth variant="outlined">
                      <InputLabel>State</InputLabel>
                      <Select value={inputFields.state} required onChange={handleSignUpChange} name="state" label="State">
                        <MenuItem value="AL">Alabama</MenuItem><MenuItem value="AK">Alaska</MenuItem>
                        <MenuItem value="AZ">Arizona</MenuItem><MenuItem value="AR">Arkansas</MenuItem>
                        <MenuItem value="CA">California</MenuItem><MenuItem value="CO">Colorado</MenuItem>
                        <MenuItem value="CT">Connecticut</MenuItem><MenuItem value="DE">Delaware</MenuItem>
                        <MenuItem value="FL">Florida</MenuItem><MenuItem value="GA">Georgia</MenuItem>
                        <MenuItem value="HI">Hawaii</MenuItem><MenuItem value="ID">Idaho</MenuItem>
                        <MenuItem value="IL">Illinois</MenuItem><MenuItem value="IN">Indiana</MenuItem>
                        <MenuItem value="IA">Iowa</MenuItem><MenuItem value="KS">Kansas</MenuItem>
                        <MenuItem value="KY">Kentucky</MenuItem><MenuItem value="LA">Louisiana</MenuItem>
                        <MenuItem value="ME">Maine</MenuItem><MenuItem value="MD">Maryland</MenuItem>
                        <MenuItem value="MA">Massachusetts</MenuItem><MenuItem value="MI">Michigan</MenuItem>
                        <MenuItem value="MN">Minnesota</MenuItem><MenuItem value="MS">Mississippi</MenuItem>
                        <MenuItem value="MO">Missouri</MenuItem><MenuItem value="MT">Montana</MenuItem>
                        <MenuItem value="NE">Nebraska</MenuItem><MenuItem value="NV">Nevada</MenuItem>
                        <MenuItem value="NH">New Hampshire</MenuItem><MenuItem value="NJ">New Jersey</MenuItem>
                        <MenuItem value="NM">New Mexico</MenuItem><MenuItem value="NY">New York</MenuItem>
                        <MenuItem value="NC">North Carolina</MenuItem><MenuItem value="ND">North Dakota</MenuItem>
                        <MenuItem value="OH">Ohio</MenuItem><MenuItem value="OK">Oklahoma</MenuItem>
                        <MenuItem value="OR">Oregon</MenuItem><MenuItem value="PA">Pennsylvania</MenuItem>
                        <MenuItem value="RI">Rhode Island</MenuItem><MenuItem value="SC">South Carolina</MenuItem>
                        <MenuItem value="SD">South Dakota</MenuItem><MenuItem value="TN">Tennessee</MenuItem>
                        <MenuItem value="TX">Texas</MenuItem><MenuItem value="UT">Utah</MenuItem>
                        <MenuItem value="VT">Vermont</MenuItem><MenuItem value="VA">Virginia</MenuItem>
                        <MenuItem value="WA">Washington</MenuItem><MenuItem value="WV">West Virginia</MenuItem>
                        <MenuItem value="WI">Wisconsin</MenuItem><MenuItem value="WY">Wyoming</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField required fullWidth id="postalCode" label="Zip Code" name="postalCode"
                      variant="outlined" value={inputFields.postalCode} onChange={handleSignUpChange} />
                  </Grid>
                </Grid>
                <Button type="submit" variant="contained" fullWidth sx={{ mt: 3, ...btnSx }}>
                  Verify Email
                </Button>
                {error && <Alert severity="error" sx={{ mt: 2 }}>{error}</Alert>}
              </Box>
            )}
          </Paper>
        </Box>

      </Box>
      </Box>
    </Box>
  );
}

export default SignInForm;